"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranscriptGetTranscriptForDubRequestFormatType = void 0;
exports.TranscriptGetTranscriptForDubRequestFormatType = {
    Srt: "srt",
    Webvtt: "webvtt",
};
